// extracted by mini-css-extract-plugin
var _1 = "ChatroomMessagesEmpty-moduleempty__j2f3C";
export { _1 as "empty" }
